import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'app-confirm-dialog',
  template: '<p-confirmdialog />',
  imports: [ConfirmDialog],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppConfirmDialog {}
